// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__r0oO7","content":"Modal_content__NBqcE","actions":"Modal_actions__MuLu2","closeIcon":"Modal_closeIcon__u5qE7"};